// extracted by mini-css-extract-plugin
export default {"header":"Question_header__coarD","count":"Question_count__M+Oan","btn":"Question_btn__SP8JV","dl":"Question_dl__KEvzP","dt":"Question_dt__cL86w","dd":"Question_dd__MEGmz"};